import pricingService from "@/services/pricingService";

export function getItemIdOld2NewMappingApi() {
  return pricingService({
    url: "/item/catalog/getItemIdOld2NewMappingForReorder",
    method: "get",
  });
}

export function createShortcutApi(data) {
  return pricingService({
    url: "/item/catalog/shortcut",
    method: "post",
    data,
  });
}

export function updateShortcutApi(data) {
  return pricingService({
    url: "/item/catalog/shortcut",
    method: "put",
    data,
  });
}

export function getShortcutsApi(params) {
  return pricingService({
    url: "/item/catalog/shortcut",
    method: "get",
    params,
  });
}

export function deleteShortcutApi(params) {
  return pricingService({
    url: "/item/catalog/shortcut",
    method: "delete",
    params,
  });
}
